import React, { useState } from 'react';
import { Button, Card, Alert, Input } from '../components/ui';
import { AddressForm } from '../components/ui/AddressForm';
import { ArrowLeft, Search, Plus } from 'lucide-react';
import { getAddresses } from "../services/addresses";
import { getOrCreateCustomer } from "../services/customers";
import { placeOrder } from '../services/orders';
import { useNavigate } from "react-router-dom";

export const CustomersScreen = () => {
    const [phoneNumber, setPhoneNumber] = useState("");
    const [addresses, setAddresses] = useState([]);
    const [showAddAddress, setShowAddAddress] = useState(false);
    const [isSearched, setIsSearched] = useState(false);
    const [searching, setSearching] = useState(false);
    const [customerId, setCustomerId] = useState();
    const [placingOrder, setPlacingOrder] = useState(false);

    const navigate = useNavigate();
    const handleAddressSaved = () => {
      fetchAddresses();
    };

    const fetchAddresses = async () => {
      setSearching(true);
      getOrCreateCustomer(`+91${phoneNumber}`)
      .then(data => {
        setCustomerId(data.id);
        getAddresses(data.id)
        .then(data => {
          setAddresses(data);
          setIsSearched(true);
          setSearching(false);
        })
        .catch(err => {
          setIsSearched(true);
          setSearching(false);
        })
      })
      .catch(err => {
        setIsSearched(true);
        setSearching(false);
      })
    };

    return (
      <div className="p-4">
        <Button
          variant="ghost"
          onClick={() => navigate("/")}
          className="mb-4 flex items-center gap-2"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Orders
        </Button>
        <h2 className="text-xl font-bold mb-4">Customer Search</h2>
        <div className="flex gap-2 mb-4">
          <Input
            type="tel"
            placeholder="Enter phone number"
            value={phoneNumber}
            onChange={(e) => setPhoneNumber(e.target.value)}
            className="flex-1"
          />
          <Button onClick={fetchAddresses} className="flex items-center gap-2" disabled={searching}>
            <Search className="h-4 w-4" />
            {searching? "Loading": "Search"}
          </Button>
        </div>
        {isSearched && addresses.length > 0 && (
          !showAddAddress ? (
            <Button
              onClick={() => setShowAddAddress(true)}
              className="mt-4 flex items-center gap-2"
            >
              <Plus className="h-4 w-4" />
              Add New Address
            </Button>
          ) : (
            <AddressForm onAddressSaved={handleAddressSaved} phoneNumber={phoneNumber} customerId={customerId}/>
          )
        )}
        {isSearched && addresses.length > 0 ? (
          <div className="space-y-2 mt-5">
            {addresses.map((address, index) => (
              <Card key={index} className="p-4">
                <p><strong>{address.full_name}</strong></p>
                <p>{address.address_1}, {address.city}, {address.state} - {address.pincode}</p>
                <p>Landmark: {address.landmark}</p>
                <p>Phone: {address.phone_number }</p>
                <Button disabled={placingOrder} onClick={() => {
                  setPlacingOrder(true);
                  placeOrder(customerId, address)
                  .then(data => {
                    setPlacingOrder(false);
                    navigate("/");
                  })
                  .catch(err => {setPlacingOrder(false);})
                }} className="mt-5">{placingOrder? "Loading" :"Place Order"}</Button>
              </Card>
            ))}
          </div>
        ) : (
          isSearched && <Alert>No addresses found</Alert>
        )}
      </div>
    );
};
